module.exports = "mutation($uuid: ID!) {\n    botSwitchPublished(uuid: $uuid)\n}\n"